import isEqual from "fast-deep-equal/react";
import { formatFilterPill } from "./formatters/format-filter-pills";
import { getFormattedBodyType, getFormattedColour, getFormattedDoors, getFormattedDriveType, getFormattedEngineSizeCcRange, getFormattedFeatures, getFormattedFuelType, getFormattedMake, getFormattedMileage, getFormattedModel, getFormattedPriceRange, getFormattedPriceRangeAndTags, getFormattedSeats, getFormattedTags, getFormattedGearbox, getFormattedVariant, getFormattedYearRange, formatFilterOptionValue } from "./formatters";
import { options } from "./formatter-options";
import { extractMappingsFromMakesFacet } from "../../utils";
import { useSearchFilters } from "../use-search-filters";
import { useSearchResults } from "../use-search-results";
import { getFormattedStoreLocations } from "./formatters/store-location-formatter";
import { getStoreDataFromAggregation } from "@cinch-nx/data-search";
let previousSearchResultsData;
let previousUseMonthly = false;
export const getAgeDataFromVehicleYearFacets = (vehicleYearFacets)=>{
    if (!vehicleYearFacets) {
        return [];
    }
    return Object.keys(vehicleYearFacets).filter((key)=>Boolean(Number.parseInt(key))).map((key)=>({
            label: key.toString(),
            value: Number.parseInt(key)
        }));
};
const summaryFormatters = {
    getFormattedMake: (value)=>getFormattedMake(value, options.mappings),
    getFormattedModel: (value)=>getFormattedModel(value, options.mappings),
    getFormattedVariant: (value)=>getFormattedVariant(value, options.mappings),
    getFormattedPriceRange: (from, to)=>getFormattedPriceRange(from, to, options.useMonthly),
    getFormattedYearRange: (from, to)=>getFormattedYearRange(from, to, options.ageData),
    getFormattedMileage,
    getFormattedFuelType,
    getFormattedColour,
    getFormattedBodyType,
    getFormattedGearbox,
    getFormattedEngineSizeCcRange,
    getFormattedDoors,
    getFormattedSeats,
    getFormattedDriveType,
    getFormattedTags,
    getFormattedFeatures,
    getFormattedPriceRangeAndTags: (from, to, tags)=>{
        return getFormattedPriceRangeAndTags(getFormattedPriceRange(from, to), getFormattedTags(tags));
    },
    getFormattedStoreLocations
};
export function useSearchFiltersFormatting() {
    const { params , useMonthly  } = useSearchFilters();
    const { data: searchResultsData  } = useSearchResults(params);
    if (searchResultsData && !isEqual(searchResultsData, previousSearchResultsData)) {
        var ref, ref1, ref2;
        options.ageData = getAgeDataFromVehicleYearFacets(searchResultsData === null || searchResultsData === void 0 ? void 0 : (ref = searchResultsData.facets) === null || ref === void 0 ? void 0 : ref.vehicleYear);
        options.mappings = extractMappingsFromMakesFacet((searchResultsData === null || searchResultsData === void 0 ? void 0 : (ref1 = searchResultsData.facets) === null || ref1 === void 0 ? void 0 : ref1.makes) ?? []);
        options.storeData = getStoreDataFromAggregation((searchResultsData === null || searchResultsData === void 0 ? void 0 : (ref2 = searchResultsData.facets) === null || ref2 === void 0 ? void 0 : ref2.store) ?? {});
        options.facets = searchResultsData === null || searchResultsData === void 0 ? void 0 : searchResultsData.facets;
        previousSearchResultsData = searchResultsData;
    }
    if (!isEqual(useMonthly, previousUseMonthly)) {
        options.useMonthly = useMonthly;
        previousUseMonthly = useMonthly;
    }
    return {
        ageData: options.ageData,
        formatFilterPill,
        summaryFormatters,
        formatFilterOptionValue
    };
}
